export const TIMEZONE = 'America/Manaus';

export function todayInManaus() {
  return new Intl.DateTimeFormat('en-CA', { timeZone: TIMEZONE }).format(new Date());
}

/**
 * Formata uma coluna DATE ('YYYY-MM-DD') como 'DD/MM/AAAA'.
 *
 * scheduled_date é data de calendário, não instante. new Date('2026-08-23')
 * lê a string como meia-noite UTC e, renderizada em Manaus (UTC-4), retrocede
 * para 22/08. Por isso aqui não existe new Date() em ponto nenhum: a string é
 * fatiada e remontada, então o fuso do aparelho não entra na conta.
 *
 * O slice(0, 10) cobre os dois formatos que o backend pode emitir hoje:
 * 'YYYY-MM-DD' e 'YYYY-MM-DDTHH:mm:ss.sssZ'.
 */
export function formatDateBR(value) {
  if (!value) return null;

  const iso = String(value).slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}/.test(iso)) return null;

  const [yyyy, mm, dd] = iso.split('-');
  return `${dd}/${mm}/${yyyy}`;
}

/**
 * Mesma coluna DATE, por extenso em pt-BR ('sábado, 23 de agosto').
 *
 * Nome de mês e de dia da semana exigem o Intl, e o Intl exige um Date. A data
 * é montada com Date.UTC() e lida de volta com timeZone:'UTC' — construção e
 * leitura no mesmo fuso, então o calendário não desliza. Fixar o timeZone é o
 * ponto: sem isso o Intl usaria o fuso do browser, e o celular do motoboy pode
 * estar em qualquer um, inclusive configurado errado.
 */
export function formatDateLongBR(value) {
  if (!value) return null;

  const iso = String(value).slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}/.test(iso)) return null;

  const [yyyy, mm, dd] = iso.split('-').map(Number);

  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'UTC',
    weekday: 'long',
    day: 'numeric',
    month: 'long'
  }).format(new Date(Date.UTC(yyyy, mm - 1, dd)));
}
